import { useState } from "react";
import { motion } from "framer-motion";
import { Wine, Home } from "lucide-react";

const ITEMS = [
  { napkin: "/gallery-napkin-lake.jpg", home: "/gallery-home-lake.jpg", title: "Lakeside Modern", meta: "Single-Family · ~2,400 sq ft" },
  { napkin: "/gallery-napkin-cabin.jpg", home: "/gallery-home-cabin.jpg", title: "A-Frame Retreat", meta: "Cabin · ~1,200 sq ft" },
  { napkin: "/gallery-napkin-warehouse.jpg", home: "/gallery-home-warehouse.jpg", title: "Workshop & Yard", meta: "Warehouse · ~6,000 sq ft" },
];

function Card({ item, index }) {
  const [flipped, setFlipped] = useState(false);
  const [hovering, setHovering] = useState(false);
  const showNapkin = flipped || hovering;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      className="group relative overflow-hidden border border-border"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      data-testid={`gallery-card-${index}`}
    >
      <div className="relative aspect-[4/3]">
        <img src={item.home} alt={item.title}
          className="absolute inset-0 h-full w-full object-cover transition-opacity duration-500"
          style={{ opacity: showNapkin ? 0 : 1 }} />
        <img src={item.napkin} alt={`${item.title} napkin sketch`}
          className="absolute inset-0 h-full w-full object-cover transition-opacity duration-500"
          style={{ opacity: showNapkin ? 1 : 0 }} />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent" />

        {/* Stage badge */}
        <div className="absolute left-3 top-3 flex items-center gap-1.5 border border-border bg-background/80 px-2.5 py-1 font-mono2 text-[10px] uppercase tracking-widest backdrop-blur">
          {showNapkin ? <><Wine className="h-3 w-3 text-primary" /> The napkin</> : <><Home className="h-3 w-3 text-primary" /> The build</>}
        </div>
      </div>

      <div className="flex items-center justify-between border-t border-border p-4">
        <div>
          <p className="font-heading text-base font-semibold">{item.title}</p>
          <p className="font-mono2 text-[11px] uppercase tracking-widest text-muted-foreground">{item.meta}</p>
        </div>
        <button
          type="button"
          onClick={() => setFlipped((v) => !v)}
          data-testid={`gallery-toggle-${index}`}
          className="rounded-sm border border-border px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-widest text-muted-foreground transition-colors hover:border-primary hover:text-primary"
        >
          {flipped ? "See build" : "See napkin"}
        </button>
      </div>
    </motion.div>
  );
}

export default function SketchGallery() {
  return (
    <div className="grid gap-5 md:grid-cols-3" data-testid="sketch-gallery">
      {ITEMS.map((it, i) => (
        <Card key={i} item={it} index={i} />
      ))}
    </div>
  );
}
